export default {
  getHoverEvent: state => state.hoverEvent,

  getBtnAnimation: state => state.btnAnimation,

  getCtxButtons: state => state.ctxButtons,

  getMouseDown: state => state.mouseDown,

  getWeatherData: state => state.weatherData,

  getRouteName: state => state.route.name,

  // getDayPart: state => state.dayPart,

  getLang: state => state.lang,

  getChangeLang: state => state.changeLang,

  getEventsList: state => state.eventsList,

  getEventData: state => state.currentEventData,

  getEventName: state => state.currentEvent,

  getPageLoaded: state => state.allLoaded,
};



// WEBPACK FOOTER //
// ./src/store/getters.js